<template>
  <Layout>
    <Aguarde :show="httpSend"></Aguarde>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div>
            <b-tabs content-class="crypto-buy-sell-nav-content p-4" nav-class="nav-tabs-custom">
              <b-tab title="Lista de Remessas" active>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <table class="table table-centered table-nowrap">
                        <thead class="thead-light">
                        <tr>
                          <th>Remessa</th>
                          <th>Ano</th>
                          <th>Período Inicial</th>
                          <th>Período Final</th>
                          <th>Partido ou Candidato</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="r in lista_remessas" :key="r.tsr_codigo">
                          <td>
                            {{ r.tsr_remessa.toString().padStart(4, '0') }}
                          </td>
                          <td>
                            {{ r.tsr_ano }}
                          </td>
                          <td>
                            {{ r.tsr_periodo_incial | formatDate }}
                          </td>
                          <td>
                            {{ r.tsr_periodo_final | formatDate }}
                          </td>
                          <td>
                            {{ r.tsr_tomador_especifico }}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Nova Remessa">
                <div class="row">
                  <div class="col-md-3">
                    <b-form-group label="Ano Eleitoral" label-for="tsel_ano">
                      <select id="tsel_ano"
                              v-model="filtro.tsel_ano"
                              class="custom-select" type="text">
                        <option value="2022">2022</option>
                      </select>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group
                        label="Inicio do Período"
                        label-for="periodo_incial">
                      <input
                          id="periodo_incial"
                          v-mask="'##/##/####'"
                          v-model="filtro.periodo_incial"
                          type="text"
                          maxlength="10"
                          class="form-control"
                          placeholder="Dia/Mês/Ano">
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group
                        label="Final do Período"
                        label-for="periodo_final">
                      <input
                          id="periodo_final"
                          v-mask="'##/##/####'"
                          v-model="filtro.periodo_final"
                          type="text"
                          maxlength="10"
                          class="form-control"
                          placeholder="Dia/Mês/Ano">
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group label="Partido ou Candidato" label-for="tsr_tomador_especifico">
                      <multiselect
                          v-model="filtro.tsr_tomador_especifico"
                          track-by="tsel_cnpj"
                          label="tsel_nome"
                          id="rel_empresa"
                          placeholder=""
                          :loading="isLoading"
                          @select="selectEmpresa"
                          @remove="removeEmpresa"
                          @search-change="pesquisarEleicoes"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :options="list_candidatos"
                          :selectLabel="'Pressione enter para selecionar'"
                          :selectedLabel="'Selecionado'"
                          :deselectLabel="'Pressione enter para remover'"
                          :searchable="true"
                          :internal-search="false"
                          :openDirection="'bottom'"
                          :tagPosition="'bottom'">
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                    <span class="option__title">
                      Razão Social: {{ props.option.tsel_nome }}
                      <br>
                      CNPJ: {{ props.option.tsel_cnpj | VMask('##.###.###/####-##') }}
                    </span>
                          </div>
                        </template>
                        <span slot="noOptions">Razão social ou CNPJ</span>
                        <span slot="noResult">Partido ou Candidato não localizado</span>
                      </multiselect>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group>
                      <button type="button" @click="pesquisaCandidatos()" class="btn btn-label btn-primary"><i
                          class="bx bx-search label-icon"></i>
                        Pesquisar
                      </button>
                    </b-form-group>
                  </div>
                </div>
                <div v-show="filtro_remessa" class="row">
                  <div v-show="list_notas && list_notas.length === 0" class="col-md-8">
                    <div class="alert alert-info text-dark"
                         role="alert"><h5>Nenhuma nota fiscal encontrada para o período informado</h5>
                      <p>Nenhuma nota fiscal foi encontrada para o período informado, porém é possível gerar o arquivo
                        de
                        remessa sem notas fiscais.</p>
                    </div>
                  </div>
                  <div v-show="list_notas && list_notas.length > 0" class="col-md-12">
                    <div class="table-responsive">
                      <table class="table table-centered table-nowrap">
                        <thead class="thead-light">
                        <tr>
                          <th>CPF/CNPJ Prestador</th>
                          <th class="text-left">Razão Social Prestador</th>
                          <th class="text-left">CPF/CNPJ Tomador</th>
                          <th class="text-left">Razão Social Tomador</th>
                          <th class="text-left">NFS-e</th>
                          <th class="text-left">Emissão</th>
                          <th class="text-center">Status</th>
                          <th class="text-right">Valor</th>
                          <th class="text-right">ISS</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="e in list_notas" :key="e.not_codigo">
                          <td>
                            {{ e.sep_cpf_cnpj_prestador }}
                          </td>
                          <td>
                            {{ e.sep_razao_social_prestador }}
                          </td>
                          <td>
                            {{ e.sep_cpf_cnpj_tomador }}
                          </td>
                          <td>
                            {{ e.sep_razao_social_tomador }}
                          </td>
                          <td>
                            <router-link
                                tag="a"
                                target="_blank"
                                :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: e.not_hash}}">
                              {{ e.not_numero }}
                            </router-link>
                          </td>
                          <td>
                            {{ e.emissao }}
                          </td>
                          <td class="text-center">
                            <span v-show="e.soc_codigo" class="badge badge-danger font-size-12">Cancelada</span>
                            <span v-show="e.not_numero && !e.soc_codigo"
                                  class="badge badge-success font-size-12">Emitida</span>
                          </td>
                          <td class="text-right">
                            {{ e.not_valor_liquido | formatNumeroBr }}
                          </td>
                          <td class="text-right">
                            {{ e.sep_iss | formatNumeroBr }}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <b-form-group>
                      <button type="button" @click="confirmacao()" class="btn btn-label btn-success"><i
                          class="bx bx-folder-open label-icon"></i>
                        Gerar Remessa
                      </button>
                    </b-form-group>
                  </div>
                  <div v-show="link_arquivo" class="col-md-6">
                    <div role="alert" aria-live="polite"
                         aria-atomic="true"
                         class="alert alert-success">
                      Remessa gerada com sucesso
                      <br><a v-bind:href="link_arquivo" target="_blank" class="alert-link"><i
                        class="mdi mdi-download mr-2"></i>
                      Clique aqui para baixar a remessa</a>
                    </div>
                  </div>
                </div>
                <br>
                <br>
                <br>
                <br>
                <br>
                <br>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import appConfig from "@/dados/app.config.json";
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import Aguarde from "@/components/widgets/aguarde";
import Swal from "sweetalert2";
import moment from "moment";
import Multiselect from 'vue-multiselect'
import {listRemessaTse, remessaTseGerar, remessaTseNotas} from "../../../../api/admin/gestao/remessa_tse";
import {openDownloadFile} from "../../../../api/core/download";
import {autocompleteEleicoes} from "../../../../api/geral/autocomplete";

export default {
  page: {
    title: "Remessa para o TSE",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Aguarde,
    Multiselect,
  },
  data() {
    return {
      title: "Remessa para o TSE",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Remessa para o TSE',
          active: true,
        },
      ],
      httpSend: false,
      isLoading: false,
      lista_remessas: [],
      filtro: {
        tsel_ano: "2022",
        periodo_incial: moment().subtract(1, "days").format('DD/MM/YYYY'),
        periodo_final: moment().format('DD/MM/YYYY'),
        tsr_tomador_especifico: null
      },
      list_candidatos: [],
      filtro_remessa: null,
      list_notas: [],
      link_arquivo: null
    };
  },
  created() {
    this.listRemessas()
  },
  methods: {
    listRemessas() {
      this.httpSend = true;
      listRemessaTse().then(response => {
        if (response.status) {
          this.lista_remessas = response.dados;
        }
      }).catch(error => {
        this.$toast.error(error);
      }).finally(() => {
        this.httpSend = false
      })
    },
    pesquisaCandidatos() {
      this.filtro_remessa = null;
      this.list_notas = null;
      this.link_arquivo = null;
      this.httpSend = true;
      remessaTseNotas(this.filtro).then(response => {
        if (response.status) {
          this.filtro_remessa = response.dados.filtro_remessa;
          this.list_notas = response.dados.notas;
        }
      }).catch(error => {
        this.$toast.error(error);
      }).finally(() => {
        this.httpSend = false
      })
    },
    removeEmpresa() {
      this.filtro.tsr_tomador_especifico = null
    },
    selectEmpresa(empresa) {
      if (empresa) {
        this.filtro.tsr_tomador_especifico = empresa.tsel_cnpj
      } else {
        this.filtro.tsr_tomador_especifico = null
      }
    },
    pesquisarEleicoes(search) {
      if (search && search.length > 1) {
        this.isLoading = true;
        autocompleteEleicoes({ano: this.filtro.tsel_ano, query: search}).then(response => {
          if (response.status) {
            if (response.dados) {
              this.list_candidatos = response.dados
            }
          }
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          this.isLoading = false;
        })
      }
    },
    confirmacao() {
      Swal.fire({
        title: "Deseja gerar a remessa",
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.isConfirmed) {
          this.gerarRemessa();
        }
      });
    },
    gerarRemessa() {
      this.httpSend = true;
      remessaTseGerar(this.filtro_remessa).then(response => {
        if (response.status) {
          this.link_arquivo = openDownloadFile(4, response.dados.file, 'remessa_' + response.dados.name)
          this.listRemessas()
        }
      }).catch(error => {
        this.$toast.error(error);
      }).finally(() => {
        this.httpSend = false
      })
    },
  }
};
</script>


